import PropTypes from 'prop-types'
import { Base64 } from 'js-base64'
import { parseCookies } from 'nookies'

import Redirect from 'helpers/redirect'
import withSignUp from 'hocs/withSignUp'
import { getAppRoute } from 'helpers/application'

import SignUp from './Screen'

const SignUpHOC = Component => {
  const Wrapper = props => <Component {...props} />

  Wrapper.getInitialProps = async ctx => {
    const pageRedirection = () => {
      Redirect('/download-app', ctx)
    }

    const {
      query: {
        redirectTo,
        application,
        signup_data,
        facebookToken,
        apple_login_token,
      },
    } = ctx

    const accessToken = parseCookies(ctx).citifyd_access_token

    let queryData

    if (signup_data) {
      queryData = JSON.parse(Base64.decode(ctx.query.signup_data))
    }

    if (
      !redirectTo &&
      !facebookToken &&
      !apple_login_token &&
      process.env.NEXT_PUBLIC_ENABLE_PAY_BY_SIGNAGE_ONLY
    ) {
      pageRedirection()
    }

    if (accessToken && !queryData) {
      if (redirectTo) {
        Redirect(redirectTo, ctx)
      } else {
        Redirect(`${getAppRoute(application, 'url')}/events`, ctx)
      }
    }

    return { queryData }
  }

  Wrapper.propTypes = {
    application: PropTypes.string,
    queryData: PropTypes.any,
    router: PropTypes.object,
  }

  return Wrapper
}

export default withSignUp(SignUpHOC(SignUp))
